"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bolt__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f46126f3-7d3b-4401-a4b8-d15e596e70cc",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bc1aa3f8-8c28-430b-85e5-6c4f4c59df9a{fill:none;}.a55e0543-2d14-483d-8371-dacc68370f5a{fill:#e60000;}.afc81879-c415-4e0d-94b1-3c44f1277710{opacity:0.12;}")), /*#__PURE__*/React.createElement("title", null, "bolt-hi"), /*#__PURE__*/React.createElement("g", {
    id: "a803b1f3-f28b-4dcd-b9c7-95240fa2b416",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ae35cca4-7234-431a-93d3-5d9c933ea29c",
    "data-name": "Bounding Box",
    className: "bc1aa3f8-8c28-430b-85e5-6c4f4c59df9a",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "a55e0543-2d14-483d-8371-dacc68370f5a",
    d: "M137.11,76h-27.8l30.35-55.27a2.88,2.88,0,0,0-2.55-4.23H91.25a2.89,2.89,0,0,0-2.67,1.77L52.8,104a2.87,2.87,0,0,0,2.67,4h21L65.37,172.64a2.87,2.87,0,0,0,1.71,3.13,3,3,0,0,0,1.13.23,2.91,2.91,0,0,0,2.33-1.17l68.9-94.25A2.88,2.88,0,0,0,137.11,76Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "afc81879-c415-4e0d-94b1-3c44f1277710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,105H55.47a2.9,2.9,0,0,1-2.41-1.28s0-.1-.07-.15l-.19.45a2.87,2.87,0,0,0,2.67,4h21Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.58,17.88,107.68,76h1.63l30.35-55.27a2.86,2.86,0,0,0-.07-2.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.56,77.36c-.05.07-.07.15-.12.22l-68.9,94.25A2.91,2.91,0,0,1,68.21,173a3,3,0,0,1-1.13-.23,2.85,2.85,0,0,1-1.48-1.46l-.23,1.33a2.87,2.87,0,0,0,1.71,3.13,3,3,0,0,0,1.13.23,2.91,2.91,0,0,0,2.33-1.17l68.9-94.25a2.88,2.88,0,0,0,.25-3C139.65,77.5,139.6,77.43,139.56,77.36Z",
    transform: "translate(0 0)"
  }))));
}

var _default = ic_bolt__dark;
exports.default = _default;